import alerts from "./alerts.json";
import form from "./form.json";

const DepositRequestConfig = {
    alerts,
    form,
};

export default DepositRequestConfig;